import { Users, ShieldCheck, Award, MapPin } from "lucide-react";

const ITEMS = [
  { icon: Users, text: "MII DE CLIENȚI MULȚUMIȚI" },
  { icon: ShieldCheck, text: "PRODUSE TESTATE ȘI APROBATE" },
  { icon: Award, text: "CALITATE GARANTATĂ" },
  { icon: MapPin, text: "FABRICAT ÎN ROMÂNIA" },
];

export const TrustBand = () => {
  return (
    <section className="bg-navy" data-testid="trust-band">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {ITEMS.map(({ icon: Icon, text }) => (
            <div key={text} className="flex items-center gap-3 justify-center md:justify-start">
              <span className="bg-white/10 rounded-full p-3 shrink-0">
                <Icon className="h-6 w-6 text-gold" />
              </span>
              <span className="font-display font-bold text-white text-xs sm:text-sm leading-tight">{text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
